export default __webpack_public_path__ + "static/media/max_rose.b2b090fb.webp";